import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const ordenarEventos = (eventos) => {
  const hoy = moment(new Date());

  const eventosOrdenados = [...eventos]
    .map((evento) => ({
      evento: evento,
      fechas: evento.Fechas.filter((f) => {
        if (f.Fecha) {
          if (moment(f.Fecha).isSameOrAfter(hoy, "day")) {
            return true;
          } else {
            return false;
          }
        } else {
          if (
            hoy.isBetween(moment(f.Inicio), moment(f.Fin), "day", "[]") ||
            moment(f.Inicio).isSameOrAfter(hoy, "day")
          ) {
            return true;
          } else {
            return false;
          }
        }
      }).sort((a, b) => {
        if (a.Fecha && b.Fecha) {
          if (moment(a.Fecha).isBefore(moment(b.Fecha), "day")) {
            return -1;
          }
          if (moment(a.Fecha).isAfter(moment(b.Fecha), "day")) {
            return 1;
          }
        } else if (a.Fecha) {
          if (moment(a.Fecha).isBefore(moment(b.Inicio), "day")) {
            return -1;
          }
          if (moment(a.Fecha).isAfter(moment(b.Inicio), "day")) {
            return 1;
          }
        } else if (b.Fecha) {
          if (moment(a.Inicio).isBefore(moment(b.Fecha), "day")) {
            return -1;
          }
          if (moment(a.Inicio).isAfter(moment(b.Fecha), "day")) {
            return 1;
          }
        } else {
          if (moment(a.Inicio).isBefore(moment(b.Inicio), "day")) {
            return -1;
          }
          if (moment(a.Inicio).isAfter(moment(b.Inicio), "day")) {
            return 1;
          }
        }
        return 0;
      }),
    }))
    .sort((a, b) => {
      if (a.fechas.length && b.fechas.length) {
        if (a.fechas[0] === undefined || a.fechas[0].Fecha === undefined) console.log(`fecha no definida o evento : ${JSON.stringify(a)}`);
        if (b.fechas[0] === undefined || b.fechas[0].Fecha === undefined) console.log(`fecha no definida o evento : ${JSON.stringify(b)}`);
        
        try {
          if (a.fechas[0].Fecha && b.fechas[0].Fecha) {
            if (
              moment(a.fechas[0].Fecha).isBefore(moment(b.fechas[0].Fecha), "day")
            ) {
              return -1;
            }
            if (
              moment(a.fechas[0].Fecha).isAfter(moment(b.fechas[0].Fecha), "day")
            ) {
              return 1;
            }
          } else if (a.fechas[0].Fecha) {
            if (
              moment(a.fechas[0].Fecha).isBefore(
                moment(b.fechas[0].Inicio),
                "day"
              )
            ) {
              return -1;
            }
            if (
              moment(a.fechas[0].Fecha).isAfter(moment(b.fechas[0].Inicio), "day")
            ) {
              return 1;
            }
          } else if (b.fechas[0].Fecha) {
            if (
              moment(a.fechas[0].Inicio).isBefore(
                moment(b.fechas[0].Fecha),
                "day"
              )
            ) {
              return -1;
            }
            if (
              moment(a.fechas[0].Inicio).isAfter(moment(b.fechas[0].Fecha), "day")
            ) {
              return 1;
            }
          } else {
            if (
              moment(a.fechas[0].Inicio).isBefore(
                moment(b.fechas[0].Inicio),
                "day"
              )
            ) {
              return -1;
            }
            if (
              moment(a.fechas[0].Inicio).isAfter(
                moment(b.fechas[0].Inicio),
                "day"
              )
            ) {
              return 1;
            }
              }
          
              } catch (error) {
        
          console.log("Ordenar Eventos exception una de los eventos no tiene fechas");
          
              }

      } else {
        console.log("una de los eventos no tiene fechas");
      }
      return 0;
    });

  return eventosOrdenados;
};

export default ordenarEventos;
